import styled from "styled-components"
import SubStatusBar from "./SubStatusBar"

const Statuses = styled.div`
  display: flex;
  flex: 1;
`

const StatusItem = styled.div`
  color: #565656;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
  border-right: solid 1px #dedede;
  border-bottom: solid 1px #dedede;
  padding: 2px 0;

  &.done {
    border-bottom: solid 1px rgb(2, 128, 198);
  }

  &.current-status {
    background: rgb(240, 250, 255);
    color: rgb(2, 128, 198);
    font-weight: bold;
  }

  &.current-status.inactive {
    background: #f8f9fc;
    color: #565656;
  }

  &.current-status.error {
    background: rgb(239, 12, 12);
    color: white;
  }

  &.last {
    border-right: none;
  }
`

/*
const statusMapSb = {
  'ImportReview': 'Import Review',
  'Processing': 'Processing',
  'PartiallyFulfilled': 'Partially Fulfilled',
  'Fulfilled': 'Fulfilled',
  'Completed': 'Completed', // Custom status, not from SB
  'Cancelled': 'Cancelled',
  'Exception': 'Exception'
}
*/

const derivedStatusMapSb = {
  'ImportReview': { index: 0, display: 'Import Review' },
  'Processing': { index: 10, display: 'Processing' }, // Custom status, modified from SB
  'InTransit': { index: 20, display: 'Shipped' }, // Custom status, not from SB
  'Completed': { index: 30, display: 'Delivered', isShowAsSingleEntry: true }, // Custom status, not from SB
  'Cancelled': { index: 80, display: 'Cancelled', isHideInTimeline: true, isShowAsSingleEntry: true },
  'Exception': { index: 90, display: 'Exception', isHideInTimeline: true, isShowAsSingleEntry: true },
}

/*
const statusMapSbShipment = {
  'None': 'None', 
  'Processing': 'Processing', 
  'Completed': 'Completed', 
  'Exception': 'Exception', 
  'OnHold': 'On Hold', 
  'Cancelled': 'Cancelled', 
  'CleanSweeped': 'Clean Sweeped', 
  'LabeledCreated': 'Label Created', 
  'ImportReview': 'Import Review'
}
*/

const statusMapDb = {
  'draft': { index: 0, display: 'Draft' },
  'finalized': { index: 10, display: 'Finalized' },
  'cancelled': { index: 20, display: 'Cancelled' }
}

/*
const trackingMapSbCarrier = [
  'FedEx', 
  'ShipBob Freight'
]
*/

export default ({
  orderEx,
  isInactive,
  isException,
  updateSbOrderData
}) => {
  const {
    data,
    dataSb
  } = orderEx

  const {
    source,
    status: statusParam,
    status_derived
  } = dataSb || data

  const isSb = source === 'sb'

  const status = (isSb ? status_derived : statusParam)
  const statusMap = (isSb ? derivedStatusMapSb : statusMapDb)

  const {
    index = 0,
    display,
    isShowAsSingleEntry
  } = statusMap[status] || {}

  return (
    <div>
      <Statuses>
        {
          isInactive || isShowAsSingleEntry ?
            <StatusItem className={
              'current-status last'
              + (isException ? ' error ' : isInactive && ' inactive ') 
            }>
              {display}
            </StatusItem> 
            :
            <>
              {Object.entries(statusMap).filter(([_, val]) => !val.isHideInTimeline).map(([key, val], i, arr) => 
                <StatusItem key={key} className={
                  (index >= val.index && ' done ') 
                  + (status === key && ' current-status ') 
                  + (isException ? ' error ' : isInactive && ' inactive ') 
                  + (i === arr.length - 1 && ' last ')
                }>
                  <span>{val.display}</span>
                </StatusItem>
              )}
            </>
        }
      </Statuses>
      <SubStatusBar orderEx={orderEx} isInactive={isInactive} updateSbOrderData={updateSbOrderData} />
    </div>
  )
}
